import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
//import { Projectcomment } from '@src/app/models/comment';
//import { Project } from '@src/app/models/project';
import { Task } from '@src/app/models/task';
import { Timeshift } from '../model/timeshift';

@Injectable({
  providedIn: 'root'
})
export class ProjecttimeshiftService {

  constructor(private http: HttpClient) { }
 

  timeshiftTask(timeshift: Timeshift) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //  PUT / organization / { organizationId } / project / { projectId } / pit / { pitdate } / timeshift
    return this.http.put<any>(environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/project/' + SessionHelper.getCurrentProject() + '/pit/' + new Date().toISOString() + '/timeshift', timeshift, httpOptions);
  }
  
}
